<template>
  <div class="rsvp-track margin-b-l" v-if="rsvp !== null">
    <div class="row">
      <div class="large-12 column">
        <div class="back-to-flight">
          <span @click="backToFlights">
            <i class="fas fa-chevron-left"></i>
            <u v-if="asapDirect">Back to Home page</u>
            <u v-else>Back</u>
          </span>
        </div>
        <h3 class="title margin-v-z medium-padding-h-s padding-b-xs">{{ $t('rsvpTrack.trackRsvp') }} {{ rsvp.id }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="large-8 column padding-r-s medium-padding-h-s">
        <div class="map margin-b-m medium-margin-b-s">
          <tracking-map2></tracking-map2>
        </div>
        <driver-information></driver-information>
      </div>
      <div class="large-4 column padding-l-s medium-padding-h-s medium-margin-t-s">
        <reservation-details class="margin-b-m medium-margin-b-s"></reservation-details>
        <consumer-app-links v-if="false"></consumer-app-links>
        <a class="op-btn btn-lg btn-danger btn-block cancel-rsvp-btn" v-if="showCancelBtn"
          href="javascript:;" @click="showCancellation">Cancel Ride</a>
        <a class="cancel-btn" href="#/search-track" @click="back($event)" v-if="false">{{ $t('rsvpTrack.returnHome') }}</a>
      </div>
    </div>

    <cancel-reservation></cancel-reservation>
  </div>
</template>

<script type="text/javascript">
import ConsumerAppLinks from './ConsumerAppLinks'
import DriverInformation from './DriverInformation'
import ReservationDetails from './ReservationDetails'
import CancelReservation from '../RsvpEdit/CancelReservation'
import TrackingMap2 from './Map2'

export default {
  name: 'rsvp-track',
  components: { ConsumerAppLinks, DriverInformation, ReservationDetails, TrackingMap2, CancelReservation },
  data () {
    return {
      asapDirect: false
    }
  },
  computed: {
    rsvp () { return this.$store.state.rsvpTrack.rsvp },
    brandCode () { return this.$store.state.brandCode },
    track () { return this.$store.state.flights.track },
    showCancelBtn () {
      if (this.rsvp.isLyft && this.rsvp.lyft) {
        return ['pending', 'accepted'].indexOf(this.rsvp.lyft.status) > -1
      }
      return ['dispatched', 'ontheway', 'arrived'].indexOf(this.rsvp.dispatchStatus) > -1
    }
  },
  methods: {
    back (event) {
      if (event) event.preventDefault()

      document.body.classList.remove('widget-full')

      if (this.asapDirect) {
        this.$root.$router.push('search')
        window.location.href = '#/search'
        return
      }

      this.$root.$router.push('search-track')
      window.location.href = '#/search-track'
    },
    backToFlights () {
      if (this.asapDirect) {
        document.body.classList.remove('widget-full')
        this.$root.$router.push('search')
        window.location.href = '#/search'
        return
      }

      this.$router.push('my-flights')
    },
    showCancellation () {
      this.$store.commit('rsvpEdit/setCancellationData', {
        show: true,
        type: 'track'
      })
    }
  },
  mounted () {
    this.$store.commit('setCurrentIndex', -1)
    if (this.$store.state.rsvpTrack.rsvp === null) {
      this.$router.push('search-track')
      return
    }

    this.asapDirect = false
    if (this.$store.state.global.asapSuccess.show) this.asapDirect = true
  }
}
</script>

<style lang="scss" scoped>
.icon-font{ margin: 10px 0!important; }
.logo{
  text-align: center;
  margin: 10px 0;
  img { width: 250px; }
}

.back-to-flight{
  margin-bottom: 20px;

  span{
    cursor: pointer;
  }
  i{
    margin-right: 5px;
    vertical-align: -1px;
  }
  u{
    color: #ff9c09;
    font-weight: 600;
  }
}

.rsvp-track {
  & .title {
    text-align: center;
  }

  & .map {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    border: 1px solid rgba(0,0,0,0.2);
  }
}

.cancel-btn {
  margin-top: 5px;
  padding: 10px;
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// index.vue?3058985f